import React, {Component} from 'react';
import {Button, ListGroup, ListGroupItem, Panel} from 'react-bootstrap';
import FA from 'react-fontawesome';
import {connect} from "react-redux";
import './PricesTable.css'
import {ExternalLink} from '../helpers/EasyLinks'
import { registrationUrl} from "../../config";

const dayNames = ['One day', 'Two days', 'Three days', 'Three days + OCI Training'];

class PriceTable extends Component {
    constructor(props) {
        super(props);

        this.price = props.price;
        this.link = registrationUrl + (this.price.discountCode ? "?voucher="+this.price.discountCode : '');
    }

    render() {
        return <div className={"price-table " + (this.price.soldOut ? " sold-out" : "") + (this.price.open ? "" : " not-open")}>
            <Panel>
                <Panel.Heading>
                    <Panel.Title className="name" componentClass="h2">
                        {this.price.name}
                    </Panel.Title>
                </Panel.Heading>
                {this.price.discount && <Panel.Body className={"description "}>{this.price.discount}</Panel.Body>}
                {this.price.description && <Panel.Body className={"description "}>{this.price.description}</Panel.Body>}
                <ListGroup className="prices">
                    {this.price.prices.map((price, index) => (
                        <ListGroupItem className={'price' + index} key={index}>
                            <div className="pull-right"> € {price} </div>
                            <div className="text-left">{dayNames[index]}:</div>
                            {index === 2 && this.price.open &&
                            <div className="best-value">Best Conference Value!</div>}
                            {index === 3 && this.price.open &&
                            <div className="best-value">Best Over-All Value!</div>}
                        </ListGroupItem>
                    ))}
                </ListGroup>
                <Panel.Body className="button">
                    {this.price.open &&
                    <ExternalLink link={this.link} className="btn btn-buy"><FA name="star"/> Buy now <FA name="star"/></ExternalLink>
                    }
                    {!this.price.open && !this.price.soldOut &&
                    <Button bsStyle="info" disabled={true}>Not Open Yet</Button>
                    }
                    {!this.price.open && this.price.soldOut &&
                    <Button bsStyle='warning' disabled={true}>Sold Out</Button>
                    }
                </Panel.Body>
            </Panel>
        </div>;
    }
}


class PriceTables extends Component {
    render() {
        return <div className="price-tables">
            {this.props.prices && this.props.prices.map((price, index) => (
                <PriceTable price={price} key={index}/>
            ))}
        </div>
    }
}

const mapStateToProps = state => {
    return {prices: state.prices};
};

const Prices = connect(mapStateToProps)(PriceTables);


export default Prices;



// WEBPACK FOOTER //
// ./src/components/prices/PricesTable.js